import React, { Component } from 'react';

import Loadable from 'react-loadable';
import Loading from './Components/Loading.jsx';

import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import './App.css';

const HomeLoadable = Loadable({
  loader: () => import('./Components/Home.jsx'),
  loading: () =>  <Loading />,
});

const Footer = Loadable({
  loader: () => import('./Components/Footer.jsx'),
  loading: () => <div style={{height: '100%', background: '#222'}}></div>,
});

const Header = Loadable({
  loader: () => import('./Components/Navigation.jsx'),
  loading: () => <div className="wrapper loading"><div className="lower"><h1 className="clearfix">Toiminimi Jukka Mustakallio</h1></div></div>,
});

const About = Loadable({
  loader: () => import('./Components/About.jsx'),
  loading: () => <Loading />,
});

const Rails = Loadable({
  loader: () => import('./Components/Galleries/Rails.jsx'),
  loading: () => <Loading />,
});

const Bars = Loadable({
  loader: () => import('./Components/Galleries/Bars.jsx'),
  loading: () => <Loading />,
});

const Balconies = Loadable({
  loader: () => import('./Components/Galleries/Balconies.jsx'),
  loading: () => <Loading />,
});

const Stairs = Loadable({
  loader: () => import('./Components/Galleries/Stairs.jsx'),
  loading: () => <Loading />,
});

const Gates = Loadable({
  loader: () => import('./Components/Galleries/Gates.jsx'),
  loading: () => <Loading />,
});

const Other = Loadable({
  loader: () => import('./Components/Galleries/Other.jsx'),
  loading: () => <Loading />,
});

class NoMatch extends Component {
  render(){
    return (
      <div>404</div>
      );
  }
}
class App extends Component {
  render() {
    return (
      <Router>
        <Route
        render={({ location }) => (
          <div className="App">
            <header className="header">
              <Header />
            </header>
            <div className="body-container clearfix">

            <TransitionGroup>
              <CSSTransition key={location.key} classNames="fade" timeout={0}>
                <Switch location={location}>
                  <Route exact path="/" component={HomeLoadable} />
                  <Route exact path="/kaiteet" component={Rails} />
                  <Route exact path="/kalterit" component={Bars} />
                  <Route exact path="/parvekkeet" component={Balconies} />
                  <Route exact path="/portaat" component={Stairs} />

                  <Route exact path="/portit" component={Gates} />
                  <Route exact path="/muu" component={Other} />
                  <Route exact path="/about" component={About} />

                  <Route component={NoMatch} />
                </Switch>
              </CSSTransition>
            </TransitionGroup>
            </div>
            <Footer />
          </div>
          )} />
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js